import type { ColumnsType } from "antd/es/table";
import { Button } from "antd";
import { langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";
import dayjs from 'dayjs';

export const generateTableColumns = (props: any): ColumnsType => {
    const { loading, operationRef} = props;
    return [
        {
            title: 'id',
            dataIndex: "Id",
        },
        {
            title: '目标数量',
            dataIndex: "Number",
        },
        {
            title: '生成数量',
            dataIndex: "ResultNumber",
        },
        {
            title: '状态',
            dataIndex: "StatusString",
        },
        {
            title: '创建时间',
            dataIndex: "CreatedAtString",
        },
    ]
}

